import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, Button, CircularProgress, Select, MenuItem, FormControl, Box } from '@mui/material'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
// import Swal from "sweetalert2";
import appConfig from "../../config/appConfig";
import * as menuActions from '../../store/actions/breadcrumb';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import RadioButtonGroup from '../../components/RadioButtonGroup';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import BusinessUnitLocationMapping from './BusinessUnitLocationMapping';
import { useForm, Controller } from 'react-hook-form';
import {  createUserWithEmailAndPassword, updateCurrentUser, updatePassword  } from 'firebase/auth';
import * as userActions from '../../store/actions/userManagement';
import {auth} from '../../config/firebase-config'
import { useLogout } from '../../components/Utils';
import { useTranslation } from 'react-i18next';

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}
const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};


const EditUser = ({setBreadcrumb,getBUnitFilterDetails, bunitFilterList, updateNewUserMgt, updatedUserMgtData, getRolesLov, rolesLov}) => {
    const langs = {
        "en": "English",
        "gr": "German",
        "sp_mex": "Spanish (Mexico)",
        "sp_sp": "Spanish (Spain)",
        "sl": "Slovakia",
        "ch": "Chinese",
        "pr": "Portuguese"
      };
    const { t } = useTranslation('common');

    const params = useLocation();
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, control, setValue } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [roles, setRoles] = useState();
    const [locationError, setLocationErr] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [defaultSelectedId, setDefaultSelectedIds] = useState([]);
    const [userID, setUserID] = useState();
    const [businessOption, setBusinessOption] = useState([])

    const [isAdminUser, setIsAdminUser] = useState("");
    const [isadminUserErr, setAdminUserErr] = useState("");
    const [isActive, setIsActive] = useState("");
    const [apiError, setAPIError] = useState("")
    const [userDetails, setUserDetals] = useState({})
    const onLogout = useLogout();
    const [language, setLanguage] = useState(""); // Default language
    const userData = JSON.parse(window.sessionStorage.getItem("userInfo"));

    const handleChange = (e) => {
        const newValue = e.target.value;
        setLanguage(newValue);
    };
    useEffect(()=>{
        if(rolesLov && rolesLov.status === 200 ){
            setRoles(rolesLov.data)
        } else if(rolesLov && rolesLov.status === 401 ){
            onLogout();
        }
    },[rolesLov])
    useEffect(()=>{
        if(params.state?.user){
            setUserDetals(params.state?.user)
            const data = params?.state?.user
            setValue('email', data.email)
            setValue('firstname', data.firstName)
            setValue('middleName', data.middleName)
            setValue('lastname', data.lastName)
            setLanguage(data.langPreference || "en")
            setValue('isAdminUser',  data?.roleId === 201 ? "Yes" : "No")
            setValue('isActive',  data?.isActive === true ? "Yes" : "No")
            setUserID(data?.id)
            setIsAdminUser(data?.roleId === 201 ? "Yes" : 'No')
            setBusinessOption(data?.locationData?.map(item => item.businessUnitName))
            // setSelectedItems(data)
            let locationData = {
            }
            data && data.locationData?.forEach(input => {
                locationData[input.businessUnitName] = input.businessLocation ? input.businessLocation : input.businessUnitLocations || []
            });
            const allLocations = Object.values(locationData).flat();
            const allItemIds = allLocations.map((item) => item.businessLocationId);
            setSelectedItems(allItemIds ? allItemIds : [])
            setDefaultSelectedIds(allItemIds ? allItemIds : [])
    // setSelectedItems(checked ? allItemIds : []);
        }

    },[params])

    useEffect(()=>{
        getBUnitFilterDetails();
      },[])

    useEffect(() => {
        const subMenuData = {
            name: t("User Management"),
            route: "/user-management",
            subRoutes: "edit-user",
            subRoutesLabel: t("Edit"),
            isSubMenu: true
        }
        getRolesLov()
        setBreadcrumb(subMenuData)
      }, []);

      const handleFormSubmit = (data) => {
        if(isAdminUser === 'No' && selectedItems && selectedItems.length === 0){
            setLocationErr(true)
            return
        }
        setLocationErr(false)
        if(!Object?.keys(errors)?.length){
            sendFormValues(data);
        }
    }
    const sendFormValues = (formData) => {
        let roleObject = [];
        setAPIError("");
        if(formData?.isAdminUser === "Yes"){
            roleObject =  roles?.filter((role)=>role.code === "ADMIN")
        }else {
            roleObject =  roles?.filter((role)=>role.code === "MRUSER")
        }
        // setIsLoading(true);
        const deletedElements = defaultSelectedId.filter(item => !selectedItems.includes(item));
        const newElements = selectedItems.filter(item => !defaultSelectedId.includes(item));
        const data = {
                "userId": userID,
                "firstName": formData?.firstname?.trim(),
                "middleName": formData?.middleName?.trim(),
                "lastName": formData?.lastname?.trim(),
                "roleId": roleObject && roleObject[0] && roleObject[0].id ? roleObject[0].id  : (formData?.isAdminUser === "Yes" ? 201 : 202),
                "isActive": formData?.isActive === "Yes" ? true : false,
                "newLocationIds": newElements || [] ,
                "langPreference": language,
                "deleteLocationIds": deletedElements || [],
                "lastModifiedBy": "Build Script",
                "isUpdateFromProfile": false
              }
              if(userData?.userId === userID) {
                const storedData = JSON.parse(window.sessionStorage.getItem("userInfo"));
                const storedData1 = JSON.parse(window.localStorage.getItem("userInfo"));
                storedData.langPreference = language; // Modify the 'language' field inside 'info'
                storedData1.langPreference = language; // Modify the 'language' field inside 'info'
                window.sessionStorage.setItem("userInfo", JSON.stringify(storedData));
                window.localStorage.setItem("userInfo", JSON.stringify(storedData1));
                sessionStorage.setItem("language", language)
              }
             updateNewUserMgt(data)
    }

    useEffect(() => {
        if(updatedUserMgtData && updatedUserMgtData.status === 200) {
            setIsLoading(false);
            if(userData?.userId === userID) {
                window.location.href = '/home';
            } else {
                window.location.href = '/user-management';
            }
        }
        else if (updatedUserMgtData && updatedUserMgtData.status === 403){
            setIsLoading(false);
            setAPIError(updatedUserMgtData.message)
        }
        else if (updatedUserMgtData && updatedUserMgtData.status === 401){
            setIsLoading(false);
            onLogout();
        }
    }, [updatedUserMgtData]);
       
    return <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h1 style={{ margin: 0, fontSize: "21px" }}><b>{t("User Management")}</b></h1>
                </Grid>
            </Grid>
          
            <hr className='blue-border' style={{marginBottom: 35}}/>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Email Address")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('email', { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i})}
                                margin="normal"
                                id="email"
                                disabled
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "email" }}
                            />
                        </div>
                        {errors?.email?.type === "required" && <span style={ErrorStyle}>{t("Please enter email id")}</span>}
                        {errors?.email?.type === "pattern" && (<span style={ErrorStyle}>{t("Please enter valid email id")}</span>)}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={4.1} xl={4.1} lg={4.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("First Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('firstname',  { required: true, validate: value => value.trim() !== '' || t("Please enter first name"),pattern: /^[A-Za-z0-9'._\-!#^~ ]+$/ })}
                                margin="normal"
                                id="firstname"
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "first name" }}
                            />
                        </div>
                        {(errors?.firstname?.type === "required" || errors?.firstname?.type === "validate") && <span style={ErrorStyle}>{t("Please enter first name")}</span>}
                        {errors?.firstname?.type === "pattern" && (<span style={ErrorStyle}>{t("Special characters not allowed")}</span>)}
                    </Grid>
                    <Grid item md={2} xl={2} lg={2} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Middle Initial")}</Typography>
                            <TextField
                                {...register('middleName',  { required: false })}
                                margin="normal"
                                id="middleName"
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "middle name" }}
                            />
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Last Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('lastname', { required: true,validate: value => value.trim() !== '' || t("Please enter last name"), pattern: /^[A-Za-z0-9'._\-!#^~ ]+$/})}
                                margin="normal"
                                id="lastname"
                                sx={textboxCss}
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "last name" }}
                            />
                        </div>
                        {(errors?.lastname?.type === "required" || errors?.lastname?.type === "validate") && <span style={ErrorStyle}>{t("Please enter last name")}</span>}
                        {errors?.lastname?.type === "pattern" && (<span style={ErrorStyle}>{t("Special characters not allowed")}</span>)}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Language")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                        <FormControl style={{width: "100%"}}>
                            <Select
                                labelId="demo-simple-select-label"
                                // id="language-select"
                                sx={textboxCss}
                                label="Language"
                                value={language}
                                onChange={handleChange}
                                renderValue={(value) => (
                                <Box sx={{ display: "flex", marginTop: '-5px' }}>
                                    {/* <img src={languageicon} alt="language" /> */}
                                    {langs[value]}
                                </Box>
                                )}
                            >
                                {Object.keys(langs).map((key) => (
                                <MenuItem key={key} value={key} style={{fontSize: 14}}>
                                    <Box >
                                    {/* <img src={languageicon} alt="language" /> */}
                                    {langs[key]}
                                    </Box>
                                </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Admin User")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="isAdminUser"
                                control={control}
                                rules={{ required: isAdminUser === "No" ? true : false}} // Add the required rule
                                render={({ field }) => (
                                    <>
                                    <RadioButtonGroup
                                        key={field.value}
                                        className={['create-using-account-radio', field.value === "Yes" ? "yes" : "no"].join(' ')}
                                        value={field.value }
                                        labels={['Yes', 'No']}
                                        handleChange={(value) => {setIsAdminUser(value.target.value); field.onChange(value);}}
                                    />
                                    {errors.isAdminUser && <span style={ErrorStyle}>{t("Please select an option")}</span>}
                                    </>
                                )}
                                />
                            </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Active")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="isActive"
                                control={control}
                                rules={{ required: t("Please select an option") }} // Add the required rule
                                render={({ field }) => (
                                    <>
                                    <RadioButtonGroup
                                        key={field.value}
                                        className={['create-using-account-radio', field.value === "Yes" ? "yes" : "no"].join(' ')}
                                        value={field.value}
                                        labels={['Yes', 'No']}
                                        handleChange={(value) => field.onChange(value)}
                                    />
                                    {errors.isActive && <span style={ErrorStyle}>{errors.isActive.message}</span>}
                                    </>
                                )}
                                />
                        </div>
                        {errors?.name?.type === "required" && <span style={ErrorStyle}>{t("Please choose the options")}</span>}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Select your Locations")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                        <BusinessUnitLocationMapping dataObj={isAdminUser} businessOption={businessOption} selectedItems={selectedItems} setSelectedItems={setSelectedItems} bunitFilterList={bunitFilterList} />
                    </Grid>
                </Grid>
                { locationError && <span style={ErrorStyle}>{t("Please choose the options")}</span>}
                <Grid container spacing={2}>
                <Grid item xs={12} sm={6.05} xl={3.05} lg={3.05} md={3.05}>
                    <Styled.PrimaryButton
                            type='submit'
                            variant="contained"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            disabled={isLoading}
                        >
                             {isLoading ? (<><CircularProgress className='progress-color' /><span style={{color:'#fff'}}>{t("Saving...")}</span></>) : <span>{t("Save")}</span>}
                        </Styled.PrimaryButton>
                    </Grid>
                    <Grid item xs={12} sm={6.05} xl={3.05} lg={3.05} md={3.05}>
                        <Styled.CancelButton
                            variant="outlined"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => navigate('/user-management')}
                        >
                            {t("Cancel")}
                        </Styled.CancelButton>
                    </Grid>
                    
                </Grid>
            </form>
    </div >
}

EditUser.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
    updateNewUserMgt: PropTypes.func.isRequired,
}


const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
        getBUnitFilterDetails: () => dispatch(userActions.getBUnitFilterDetails()),
        updateNewUserMgt: (data) => dispatch(userActions.updateNewUserMgt(data)),
        getRolesLov: () => dispatch(userActions.getRolesLov()),
    };
}
const mapStateToProps = (state) => ({ 
    updatedUserMgtData: state.userReducer.updatedUserMgtData,
    rolesLov: state.userReducer.rolesLov,
    bunitFilterList: state.userReducer.bunitFilterList,
 })


export default connect(mapStateToProps, mapDispatchToProps)(EditUser);